import { Box, BoxContent, Heading, TextLink } from '@mm/components';
import { ArrowStatefulIcon, ClockIcon } from '@mm/icons';
import { selectGuides } from '@mm/state/selectors/guideSeelectors';
import classNames from 'classnames';
import { sortBy } from 'lodash';
import React from 'react';
import { useSelector } from 'react-redux';
import { colors } from '../../../styles/colors';
import './GuidesForNewUsers.pcss';

type Props = {
  className?: string;
};

export const GuidesForNewUsers = ({ className }: Props) => {
  const guides = useSelector(selectGuides);

  if (!guides.length) return null;

  return (
    <div className={classNames(className, 'guides-for-new-users')}>
      <Heading size={2} text="Get started with these step-by-step guides" />
      {guides.length && (
        <div className="guides-for-new-users__guides">
          {sortBy(guides, 'sortOrder').map((guide, idx) => {
            const time = guide.readTimeMinutes;
            return (
              <a
                href={guide.link}
                key={idx}
                target="blank"
                className="guides-for-new-users__guide-anchor"
              >
                <Box
                  className={classNames('guides-for-new-users__guide', {
                    'guides-for-new-users__guide--green': time && time <= 5,
                    'guides-for-new-users__guide--purple':
                      time && time > 5 && time <= 15,
                    'guides-for-new-users__guide--blue': time && time > 15,
                  })}
                >
                  {!!time && (
                    <span className="guides-for-new-users__time">
                      <ClockIcon
                        className="guides-for-new-users__time-icon"
                        color="white"
                      />
                      {time} min
                    </span>
                  )}
                  <BoxContent className="guides-for-new-users__guide-content">
                    <Heading
                      size={4}
                      text={guide.name}
                      className="guides-for-new-users__guide-title"
                    />
                    <TextLink className="guides-for-new-users__guide-description">
                      {guide.description}
                    </TextLink>

                    {!!guide.buttonName && (
                      <TextLink className="guides-for-new-users__guide-link">
                        {guide.buttonName}
                        <ArrowStatefulIcon
                          className="guides-for-new-users__guide-link-icon"
                          color={colors.accentBlue}
                          size={13}
                        />
                      </TextLink>
                    )}
                  </BoxContent>
                </Box>
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};
